export const SET_LAYOUT = "setLayout"
export const TOGGLE_SIDE_BAR = "toggleSideBar"
export const TOGGLE_SEARCH = "toggleSearch"
export const TOGGLE_LOCALE = "toggleLocale"
export const TOGGLE_DARK_MODE = "toggleDarkMode"
export const TOGGLE_MENU_STYLE = "toggleMenuStyle"
export const TOGGLE_LAYOUT_STYLE = "toggleLayoutStyle"
export const SET_AUTH_DATA = "setAuthData"
export const LOG_OUT_USER = "LOG_OUT_USER"
export const IS_LOADING = "IS_LOADING"
export const LOGIN = "LOGIN"
export const CHANGE_TEMPORARY_PASSWORD = "LOGIN_REQUEST"
export const FORGET_PASSWORD_REQUEST = "FORGET_PASSWORD_REQUEST"
export const CONFIRM_FORGET_PASSWORD_REQUEST = "CONFIRM_FORGET_PASSWORD_REQUEST"
export const EDIT = "Edit"
export const DELETE = "Delete"
export const DETAILS = "Details"

